import luxon from "luxon";
const { DateTime } = require('luxon')

/**
 * ISO8601形式文字列よりDateTime型に変換する
 * @param iso8601 ISO8601形式時刻表示文字列
 * @return luxon.DateTime型の時刻情報
 */
export const toLuxonDateTime = (iso8601: string): luxon.DateTime => {
  return DateTime.fromISO(iso8601, { zone: 'Asia/Tokyo', setZone: true });
}

/**
 * UNIXTIMEよりDateTime型に変換する
 * @param unixtime UNIXTIMEの時刻情報
 * @return luxon.DateTime型の時刻情報
 */
export const toLuxonDateTimeFromUnixTime = (unixtime: number): luxon.DateTime => {
  return DateTime.fromSeconds(unixtime, { zone: 'Asia/Tokyo' });
}

/**
 * Date型よりDateTime型に変換する
 * @param date JavaScriptデフォルトのDate型
 * @returns luxon.DateTime型の時刻情報
 */
export const toLuxonDateTimeFronJSDate = (date: Date): luxon.DateTime => {
  return DateTime.fromJSDate(date, { zone: 'Asia/Tokyo' });
}

/**
 * 現在時刻を取得する
 * @return luxon.DateTime型の現在時刻情報
 */
export const getNowLuxonDateTime = (): luxon.DateTime  => {
  return DateTime.now()
    .set({ second: 0, millisecond: 0 })
    .setZone('Asia/Tokyo');
}

/**
 * yyyyMMddHHmm形式の日時の文字列をluxon.DateTime型にパースする。
 * @param dateStr yyyyMMddHHmm形式の日時の文字列
 * @returns luxon.DateTime型の時刻情報
 */
export const parseFromyyyyMMddHHmm = (dateStr: string): luxon.DateTime => {
  return DateTime.fromFormat(dateStr, 'yyyyMMddHHmm', { zone: 'Asia/Tokyo' })
}

/**
 * 指定の日付の0時0分に設定する
 * @param date 任意の時刻情報
 * @returns 0時0分0秒に設定した時刻情報
 */
export const setBaseDay = (date: luxon.DateTime): luxon.DateTime => {
  return date.set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  })
}
